import { getCurrentUserFromStore } from '@lastbrand/fe-common/universal-auth'

import { EVENT_DELAY } from '@src/config/constants'
import { TelemetryIntegration } from '@src/telemetry/telemetry-events.types'
import { executeFireAndForgotTask } from '@src/utils/fire-and-forgot-task'

import { TELEMETRY_DOMAINS } from '../telemetry-domains.constants'
import { TELEMETRY_EVENT_NAMES } from '../telemetry-events.constants'

import { initializeScript } from './provider-utils/initialize-script'
export const CRITEO_ACCOUNT_ID = 74153

export const CriteoAnalytics: TelemetryIntegration = {
  config: {
    enabled: true,
    eventIdealTimeout: 1000,
    domain: TELEMETRY_DOMAINS.CRITEO_ANALYTICS,
  },
  initialize: async () => {
    await initializeScript({
      key: 'gatsby-plugin-criteo',
      domain: TELEMETRY_DOMAINS.CRITEO_ANALYTICS,
      path: '/js/ld/ld.js',
    })
  },
  events: {
    [TELEMETRY_EVENT_NAMES.HOME_PAGE_VIEW]: () => {
      sendCriteoEvent({ event: 'viewHome' })
    },

    [TELEMETRY_EVENT_NAMES.COLLECTION_VIEW]: properties => {
      const productIds = Array.from(new Set(properties.variantList.map(x => x.product_id)))
      sendCriteoEvent({ event: 'viewList', item: productIds })
    },

    [TELEMETRY_EVENT_NAMES.PRODUCT_VIEW]: properties => {
      sendCriteoEvent({ event: 'viewItem', item: properties.productId })
    },

    [TELEMETRY_EVENT_NAMES.ADD_TO_CART]: properties => {
      const items: AddToCartEvent[] = properties.lineItems.map(x => {
        return {
          id: x.productId,
          price: x.price,
          quantity: x.quantity,
        }
      })
      sendCriteoEvent({ event: 'viewBasket', item: items })
    },
  },
}

declare global {
  interface Window {
    criteo_q?: CriteoEvent[]
  }
}

interface CriteoEvent {
  event: 'setAccount' | 'setEmail' | 'setSiteType' | 'viewHome' | 'viewList' | 'viewItem' | 'viewBasket'
  account?: number
  email?: string
  type?: string
  item?: number | number[] | AddToCartEvent[]
}

interface AddToCartEvent {
  id?: string
  price: string
  quantity: number
}

interface GatsbyUserIntf {
  email?: string
}

export const sendCriteoEvent = (event: CriteoEvent) => {
  window.criteo_q = window.criteo_q ?? []
  const deviceType = navigator.userAgent.includes('iPad')
    ? `t`
    : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent)
      ? `m`
      : `d`
  const user = getCurrentUserFromStore() as GatsbyUserIntf
  const userEmail = user.email ?? ''

  executeFireAndForgotTask(() => {
    if (window.criteo_q) {
      window.criteo_q.push(
        { event: 'setAccount', account: CRITEO_ACCOUNT_ID },
        { event: 'setEmail', email: userEmail },
        { event: 'setSiteType', type: deviceType },
        event,
      )
    }
  }, EVENT_DELAY)
}
